// SVG path strings extracted from lucide icons for use in Leaflet L.divIcon HTML markers.
// React components can't be rendered in Leaflet's raw HTML, so we use inline SVG.

const CATEGORY_SVG = {
  food: [
    '<path d="m16 2-2.3 2.3a3 3 0 0 0 0 4.2l1.8 1.8a3 3 0 0 0 4.2 0L22 8"/>',
    '<path d="M15 15 3.3 3.3a4.2 4.2 0 0 0 0 6l7.3 7.3c.7.7 2 .7 2.8 0L15 15Zm0 0 7 7"/>',
    '<path d="m2.1 21.8 6.4-6.3"/>',
    '<path d="m19 5-7 7"/>',
  ],
  nature: [
    '<path d="m17 14 3 3.3a1 1 0 0 1-.7 1.7H4.7a1 1 0 0 1-.7-1.7L7 14h-.3a1 1 0 0 1-.7-1.7L9 9h-.2A1 1 0 0 1 8 7.3L12 3l4 4.3a1 1 0 0 1-.8 1.7H15l3 3.3a1 1 0 0 1-.7 1.7H17Z"/>',
    '<path d="M12 22v-3"/>',
  ],
  culture: [
    '<path d="M10 18v-7"/>',
    '<path d="M11.12 2.198a2 2 0 0 1 1.76.006l7.866 3.847c.476.233.31.949-.22.949H3.474c-.53 0-.695-.716-.22-.949z"/>',
    '<path d="M14 18v-7"/>',
    '<path d="M18 18v-7"/>',
    '<path d="M3 22h18"/>',
    '<path d="M6 18v-7"/>',
  ],
  adventure: [
    '<path d="m8 3 4 8 5-5 5 15H2L8 3z"/>',
  ],
  relaxation: [
    '<path d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5"/>',
  ],
  shopping: [
    '<path d="M16 10a4 4 0 0 1-8 0"/>',
    '<path d="M3.103 6.034h17.794"/>',
    '<path d="M3.4 5.467a2 2 0 0 0-.4 1.2V20a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6.667a2 2 0 0 0-.4-1.2l-2-2.667A2 2 0 0 0 17 2H7a2 2 0 0 0-1.6.8z"/>',
  ],
  nightlife: [
    '<path d="M20.985 12.486a9 9 0 1 1-9.473-9.472c.405-.022.617.46.402.803a6 6 0 0 0 8.268 8.268c.344-.215.825-.004.803.401"/>',
  ],
  transport: [
    '<path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z"/>',
  ],
  accommodation: [
    '<path d="M10 22v-6.57"/>',
    '<path d="M12 11h.01"/>',
    '<path d="M12 7h.01"/>',
    '<path d="M14 15.43V22"/>',
    '<path d="M15 16a5 5 0 0 0-6 0"/>',
    '<path d="M16 11h.01"/>',
    '<path d="M16 7h.01"/>',
    '<path d="M8 11h.01"/>',
    '<path d="M8 7h.01"/>',
    '<rect x="4" y="2" width="16" height="20" rx="2"/>',
  ],
  other: [
    '<path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"/>',
    '<circle cx="12" cy="10" r="3"/>',
  ],
};

export function getSvgIconHtml(categoryValue, color = 'white', size = 16) {
  const paths = CATEGORY_SVG[categoryValue] || CATEGORY_SVG.other;
  return `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="${color}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">${paths.join('')}</svg>`;
}
